import React from 'react';
import AvatarNickNameplate from '../../avatar-nick-nameplate';
import { IAddOrUpdateCommentApi, ICommentWithVipInfo } from '../../../../type';
import Style from '../../index.less';
import classNames from 'classnames';
import CommentInput from '../../comment-input/comment-input';

interface ICommentGroupItemProps extends IAddOrUpdateCommentApi {
    commentInfo: ICommentWithVipInfo;
    groupId: string;
    isLastItem: boolean;
    onEditStateChanged?: (commentId?: string, isEditing?: boolean) => void;
}

const CommentGroupEditorItem: React.FC<ICommentGroupItemProps> = (props: ICommentGroupItemProps) => {
    const { commentInfo, groupId } = props;

    return <div
        className={classNames({
            [Style['comment-group-item']]: true,
        })}
        style={props.isLastItem ? {} : { borderBottom: '1px solid #f4f4f4' }}
    >
        <AvatarNickNameplate commentInfo={commentInfo} />
        <CommentInput
            groupId={groupId}
            commentId={commentInfo.id}
            addComment={props.addComment}
            updateComment={props.updateComment}
            content={commentInfo.content}
            onEditStateChanged={props.onEditStateChanged}
            readOnly={false}
        />
    </div>;
};

export default CommentGroupEditorItem;
